module.exports = __webpack_public_path__ + "img/app-pc-qr2.d051893b.png";